import { VariableValue } from 'api/LoanOriginationSystem/Types';

export const isEmptyVariableValue = (value: VariableValue | undefined): value is null | undefined => {
  if (typeof value === 'string') {
    return !value;
  }

  return value === null || value === undefined;
};
